import React, { useState, useMemo, useEffect } from "react";
import classNames from "classnames";
import { useMediaQuery } from "react-responsive";

import { ProjectCard, Button } from "../../components";

import styles from "./OtherProjects.module.scss";

const OtherProjects = ({ projects, title, onClickButton }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const isDesktop = useMediaQuery({ minWidth: 1540 })
  const isTablet = useMediaQuery({ minWidth: 981 })
  
  useEffect(function defineNeedHiding() {
    const COLUMN_COUNT = isDesktop ? 4 : isTablet ? 3 : 1;

    const columnsTotal = projects.reduce((acc, project) => {
      const projectSpace = project.wide_block ? 2 : 1;

      return acc += projectSpace;
    }, 0);

    if (columnsTotal <= COLUMN_COUNT) {
      setIsCollapsed(false);
    } else {
      setIsCollapsed(true);
    }
  }, [isDesktop, isTablet, projects]);

  return (
    <div className={styles.OtherProjects}>
      <h2 className="h2-title title-with-mrg title-with-mrg_small">{title}</h2>

      <div
        className={classNames(
          styles.ProjectsList,
          isCollapsed && styles.Collapsed
        )}
      >
        {projects.map((item) => {
          return <ProjectCard className={styles.Project} item={item} key={item.id} />;
        })}
      </div>

      {isCollapsed && (
        <div className={styles.AlignCenter}>
          <Button className={styles.Button} onClick={() => {
              onClickButton();

              setIsCollapsed(false);
            }}>
            Показать все
          </Button>
        </div>
      )}
    </div>
  );
};

export default OtherProjects;
